/* eslint-disable max-len */
import { CartIcon as SourceCartIcon } from 'SourceComponent/CartIcon/CartIcon.component';

import './CartIcon.extension.style.scss';
/** @namespace Bodypwa/Component/CartIcon/Component */

export class CartIconComponent extends SourceCartIcon {
    render() {
        const { isActive, isTransparent = false } = this.props;

        // TODO make one svg
        if (isTransparent) {
            return (
                <svg
                  block="CartIcon"
                  mods={ { isActive } }
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                <path fill-rule="evenodd" clip-rule="evenodd" d="M3.43934 0H8.56066L9.75 1.18934V2.25H12V12H0V2.25H2.25V1.18934L3.43934 0ZM2.25 3.75V4.5H3.75V3.75H8.25V4.5H9.75V3.75H10.5V10.5H1.5V3.75H2.25ZM8.25 2.25H3.75V1.81066L4.06066 1.5H7.93934L8.25 1.81066V2.25Z" fill="#070707" />
                </svg>
            );
        }

        return (
            <svg
              block="CartIcon"
              mods={ { isActive } }
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
            <path fillRule="evenodd" clipRule="evenodd" d="M5.73223 0H14.2678L16.25 1.98223V3.75H20V20H0V3.75H3.75V1.98223L5.73223 0ZM13.75 3.75H6.25V3.01777L6.76777 2.5H13.2322L13.75 3.01777V3.75Z" />
            </svg>
        );
    }
}

export default CartIconComponent;
